import * as React from "react";
import { PropsWithChildren, useMemo } from "react";

import { useScreenSizeType } from "./screen";
import { ScreenSizeContext } from "./useScreenSize";

const ScreenSizeContextProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const { isDesktop, isTabletLandscapeUp, isPhone } = useScreenSizeType();
  const screenSize = useMemo(
    () => ({ isDesktop, isTabletLandscapeUp, isPhone }),
    [isDesktop, isTabletLandscapeUp, isPhone],
  );

  return (
    <ScreenSizeContext.Provider value={screenSize}>
      {children}
    </ScreenSizeContext.Provider>
  );
};

export default ScreenSizeContextProvider;
